module.exports = __webpack_public_path__ + "static/media/logo.f3300214.webp";